import { HeatingTypeContainer } from '../../containers/advancedFilters/HeatingTypeContainer';
import { IFilter } from '../../types/filters';

export const heatingType: IFilter = {
  component: HeatingTypeContainer,
};
